// @ts-nocheck

import { AppBar } from 'components/appBar/AppBar'
import { ButtonBack } from 'components/buttonBack/buttonBack'
import * as S from './ShowTicket.styles'
import { useSelector } from 'react-redux'
import { Hidden } from 'applaus-ui-kit'
import { formatPrice } from 'utils/formatPrice'
import { ReduxState } from 'redux/rootReducer'
import moment from 'moment'
import { useState, useEffect } from 'react'
import QRCode from 'qrcode'
import history from 'routes/services/history'
import { useParams } from 'react-router-dom'
import { ProfileTemplate } from 'components/templates/ProfileTemplate/ProfileTemplate'
import { downloadPurchasePDF } from 'api/services/purchases/downloadPurchasePDF'
import { isReceivedTransferOrder } from 'utils/isReceivedTransferOrder'
import { CancelTransferActions } from 'components/CancelTransferActions/CancelTransferActions'
import { isTicketInTransfer } from 'utils/ticketTransferUi'

export const ShowTicket = () => {
  const { id } = useParams<{ id: string }>()

  const { selectedPurchaseOrder } = useSelector(
    (state: ReduxState) => state.PurchasesReducer
  )
  const isReceived = isReceivedTransferOrder(selectedPurchaseOrder)

  const [qrCodeImage, setQrCodeImage] = useState<string[]>([])

  useEffect(() => {
    selectedPurchaseOrder?.customerTickets.map((ticket) =>
      QRCode.toDataURL(ticket.qrCode).then((response) =>
        setQrCodeImage((prev) => [...prev, response])
      )
    )
  }, [])

  const handleDownloadTicketsClick = async () => {
    await downloadPurchasePDF(id)
  }

  return (
    <ProfileTemplate active="purchases">
      <S.Container>
        <Hidden desktop>
          <AppBar />
        </Hidden>

        <S.ContentRequest>
          <Hidden tablet>
            <S.TitleRequest>Ingressos</S.TitleRequest>
          </Hidden>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              maxWidth: '800px'
            }}>
            <ButtonBack
              title={
                'Pedido: ' + selectedPurchaseOrder?.orderId.toLocaleUpperCase()
              }
              subTitle={
                (isReceived ? 'Recebido em ' : 'Comprado em ') +
                moment(
                  selectedPurchaseOrder?.updatedAt ||
                    selectedPurchaseOrder?.createdAt
                ).format('DD/MM/YYYY') +
                ' às ' +
                moment(
                  selectedPurchaseOrder?.updatedAt ||
                    selectedPurchaseOrder?.createdAt
                ).format('LT')
              }
              click={() => history.push(`/purchase/${id}`)}
            />
            <div>
              <S.DownloadButton onClick={handleDownloadTicketsClick}>
                Baixar ingresso <S.DownloadIcon />
              </S.DownloadButton>
            </div>
          </div>
          <div>
            {selectedPurchaseOrder?.customerTickets.map(
              (customerTicket, index) => (
                <S.ContentTicket key={customerTicket.id}>
                  <S.TicketBox>
                    <div className="circleLeft" />
                    <S.Ticket>
                      <div className="titleEventBox">
                        <S.TitleEvent>
                          {selectedPurchaseOrder?.eventItem.event.name}
                        </S.TitleEvent>
                        {selectedPurchaseOrder.customerTickets[index]
                          .detachedAt && (
                          <p className="ticketDetached"> (Utilizado)</p>
                        )}
                        {!selectedPurchaseOrder.customerTickets[index]
                          .detachedAt &&
                          isTicketInTransfer(
                            selectedPurchaseOrder.customerTickets[index]
                          ) && (
                            <p className="ticketDetached">
                              {' '}
                              (Em transferência)
                            </p>
                          )}
                        {!selectedPurchaseOrder.customerTickets[index]
                          .detachedAt &&
                          selectedPurchaseOrder.customerTickets[index]
                            .status === 'TRANSFERRED' && (
                            <p className="ticketDetached"> (Transferido)</p>
                          )}
                      </div>
                      <S.AddressEvent>
                        {selectedPurchaseOrder!.eventItem.event.address.street +
                          ', ' +
                          selectedPurchaseOrder!.eventItem.event.address.city}
                      </S.AddressEvent>
                      <S.Date>
                        {moment(
                          selectedPurchaseOrder?.eventItem.dates[0]
                        ).format('LLLL')}
                      </S.Date>

                      <S.TicketInfoBox>
                        <S.TicketInfo>
                          <div className="contentInfoBox">
                            <h1>Ingresso:</h1>{' '}
                            <p>{customerTicket.ticket.name}</p>
                          </div>
                          {selectedPurchaseOrder.eventItem.event.type ===
                          'MAPPED' ? (
                            <div className="contentInfoBox">
                              <h1>Setor:</h1>{' '}
                              <p>{customerTicket.ticket.category}</p>
                            </div>
                          ) : null}
                          {selectedPurchaseOrder.eventItem.event.type ===
                          'MAPPED' ? (
                            <div className="contentInfoBox">
                              <h1>Lugar:</h1> <p>{customerTicket.seatId}</p>
                            </div>
                          ) : null}
                        </S.TicketInfo>

                        <S.TicketInfo2>
                          <S.PurchaseData>
                            <div className="contentPurchaseData">
                              <h1>
                                {isReceived
                                  ? 'Recebido em:'
                                  : 'Data da compra:'}
                              </h1>{' '}
                              <p>
                                {moment(
                                  selectedPurchaseOrder?.updatedAt ||
                                    selectedPurchaseOrder?.createdAt
                                ).format('L') +
                                  ' às ' +
                                  moment(
                                    selectedPurchaseOrder?.updatedAt ||
                                      selectedPurchaseOrder?.createdAt
                                  ).format('LT')}
                              </p>
                            </div>
                            {!isReceived ? (
                              <div className="contentPurchaseData">
                                <h1>Valor:</h1>{' '}
                                <p>
                                  {formatPrice(
                                    customerTicket.ticket.totalPriceCents / 100
                                  )}
                                </p>
                              </div>
                            ) : null}
                          </S.PurchaseData>
                        </S.TicketInfo2>
                      </S.TicketInfoBox>
                    </S.Ticket>
                    <div className="circleRight" />
                  </S.TicketBox>

                  <S.QrCode>
                    <p>
                      {index + 1} de{' '}
                      {selectedPurchaseOrder.customerTickets.length} ingressos
                    </p>
                    {customerTicket.status === 'ACTIVE' &&
                    customerTicket.isValid !== false ? (
                      <>
                        <img
                          src={qrCodeImage[index]}
                          alt="QRCode"
                          className="qrCodeImage"
                        />
                        <p className="idQrCode">
                          {selectedPurchaseOrder.customerTickets[
                            index
                          ].customerTicketId.toUpperCase()}
                        </p>
                      </>
                    ) : (
                      <p className="idQrCode">
                        {isTicketInTransfer(customerTicket)
                          ? 'Ingresso em transferência'
                          : customerTicket.status === 'TRANSFERRED'
                          ? 'Ingresso transferido'
                          : 'Ingresso indisponível'}
                      </p>
                    )}
                    {isTicketInTransfer(customerTicket) ? (
                      <CancelTransferActions
                        purchaseOrderId={id}
                        tickets={[customerTicket]}
                        ButtonComponent={S.CancelTransferButton}
                        ErrorComponent={S.CancelError}
                      />
                    ) : null}
                  </S.QrCode>
                </S.ContentTicket>
              )
            )}
          </div>
        </S.ContentRequest>
      </S.Container>
    </ProfileTemplate>
  )
}
